export type PropsType={
    heading:string,
    isKeyboardRequiredOnInit:boolean,
}

export type SelectedConfigType={
    ConfigurationId:number,
    Name:string,
    label:string,
    value:string
}

export type FixMeLater=any;

export const dropDownStyle = {
  control : (baseStyles) => ({
      ...baseStyles,
      fontFamily:"roboto-regular",
      cursor:"pointer",
      fontSize:'min(0.1em, min(0.1em, 1rem))',
      minHeight:'3em',
      height:'3em'

  }),
  option: (baseStyles)=>({
    ...baseStyles,
      fontFamily:"roboto-regular",
      cursor:"pointer",
      fontSize:'min(1em, min(1em, 1rem))',
  }),
  menuList : (baseStyles)=>({
    ...baseStyles,
    fontSize:'min(0.1em, min(0.1em, 1rem))',
    fontFamily:"roboto-regular",
  }),
  valueContainer : (baseStyles)=>({
    ...baseStyles,
    height:'3em',
  }),
  input: (provided) => ({
    ...provided,
    margin: '0',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '3em',
  }),
};